// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J31AxeRQGR {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.J31AxeRQGR h4 {
  line-height: 3em;
}
.J31AxeRQGR .x1ADONo0L6 {
  float: left;
  width: 100%;
}
.J31AxeRQGR .Yr7CdLY_B1 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.J31AxeRQGR .Yr7CdLY_B1:hover {
  cursor: pointer;
}
.J31AxeRQGR .Yr7CdLY_B1:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.CUbqLuDTYG .XVT5ZaM29N:focus {
  outline: none;
}
.CUbqLuDTYG .XVT5ZaM29N.HLQjdzJQG7._QPctH5qP0 {
  background: #375A88;
}
.CUbqLuDTYG .XVT5ZaM29N.HLQjdzJQG7._QPctH5qP0 span {
  color: #fff;
}
.CUbqLuDTYG ._QPctH5qP0 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.CUbqLuDTYG ._QPctH5qP0:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.CUbqLuDTYG input {
  height: 38px;
  min-width: 220px;
}
.Yr7CdLY_B1.PKrlhAeoZ7 {
  background: #410102;
}
.Yr7CdLY_B1.Q7_khx1zeZ {
  background: #911318;
}
.Yr7CdLY_B1.ccAaR9tclE {
  background: #D8293B;
}
.Yr7CdLY_B1.RswauI5XhD {
  background: #F2373C;
}
.Yr7CdLY_B1.poVbWImNBp {
  background: #FC4448;
}
.Yr7CdLY_B1.XeOizajuIi {
  background: #ED535E;
}
.Yr7CdLY_B1.OUyQZJ1YlH {
  background: #E34926;
}
.Yr7CdLY_B1.ussZmt5FuA {
  background: #FC562B;
}
.Yr7CdLY_B1.z50XmiUntb {
  background: #FC6722;
}
.Yr7CdLY_B1.uYn7U1JRZp {
  background: #FD7F24;
}
.Yr7CdLY_B1.DBcW0adQzX {
  background: #FD8D26;
}
.Yr7CdLY_B1.V6Wgg6lKEp {
  background: #EC9C3E;
}
.Yr7CdLY_B1.DsJ2nCt_iI {
  background: #0e673a;
}
.Yr7CdLY_B1.KwQEw1EKQr {
  background: #208740;
}
.Yr7CdLY_B1.c6pt_KFOzD {
  background: #239718;
}
.Yr7CdLY_B1.ENkWT28QxW {
  background: #55A84D;
}
.Yr7CdLY_B1.Gm6UgWc7mw {
  background: #4BBE5A;
}
.Yr7CdLY_B1.kGNDCb65CK {
  background: #0CCA6A;
}
.Yr7CdLY_B1.SkQIlxqmCQ {
  background: #0A3C64;
}
.Yr7CdLY_B1.igOjr2e8ss {
  background: #0d487a;
}
.Yr7CdLY_B1.z_VpsyhE0z {
  background: #10538d;
}
.Yr7CdLY_B1.DXUWGrzIn8 {
  background: #115A99;
}
.Yr7CdLY_B1.fKXdDyPEG_ {
  background: #3387E2;
}
.Yr7CdLY_B1.akhLJXWCN8 {
  background: #1BA9CF;
}
.Yr7CdLY_B1.KkWRzNNq9N {
  background: #d27c02;
}
.Yr7CdLY_B1.QuETAfvsbs {
  background: #fb9402;
}
.Yr7CdLY_B1.oBVWyDD99a {
  background: #FD9B30;
}
.Yr7CdLY_B1.OkJPOK2R4z {
  background: #FDBE2D;
}
.Yr7CdLY_B1.Gmz_LmWqvO {
  background: #FED831;
}
.Yr7CdLY_B1.fBnPU3z3lQ {
  background: #FFFD38;
}
.Yr7CdLY_B1.a7vPVtS1K0 {
  background: #2D215C;
}
.Yr7CdLY_B1.i45IcBJrhw {
  background: #483C83;
}
.Yr7CdLY_B1.NIDrFRJSRe {
  background: #58518d;
}
.Yr7CdLY_B1.gIEISAGiUM {
  background: #7068A9;
}
.Yr7CdLY_B1.eWgf448ZVN {
  background: #7f78b2;
}
.Yr7CdLY_B1.O2H2foTAVZ {
  background: #8f88bc;
}
.Yr7CdLY_B1.Ch4Q0Hk5wo {
  background: #000;
}
.Yr7CdLY_B1.Lhdu0M9fbY {
  background: #282626;
}
.Yr7CdLY_B1.gUbAMwMEaJ {
  background: #242222;
}
.Yr7CdLY_B1.VYyqi9NjDt {
  background: #353838;
}
.Yr7CdLY_B1.g4qfE0fCGd {
  background: #666;
}
.Yr7CdLY_B1.FwWhWc002B {
  background: #999;
}
.XMVTtloyAv {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.XMVTtloyAv .xvz7k9lL5O {
  display: none;
}
.QyAwvbKssW .tILHymvLJN {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.QyAwvbKssW .tILHymvLJN .v5BoAj8NcV {
  font-size: 12px;
  margin-bottom: 0;
  text-transform: uppercase;
}
.QyAwvbKssW .alMu_XgC8z {
  background-color: #f5f6fa;
  margin-top: 12px;
}
.QyAwvbKssW .alMu_XgC8z .KjBq5KAfEX {
  padding-top: 20px;
  margin-bottom: 0;
}
.QyAwvbKssW .alMu_XgC8z .KjBq5KAfEX > div:last-child > div:first-child {
  min-height: 50px;
}
.QyAwvbKssW .alMu_XgC8z .KjBq5KAfEX .e_zPfM1jBh {
  margin-left: 24px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
}
.QyAwvbKssW .alMu_XgC8z .KjBq5KAfEX .idr9BH3Uj2 {
  background-color: #027391;
  margin-right: 24px;
}
.QyAwvbKssW .alMu_XgC8z .KjBq5KAfEX .Ry2SOtq5vn {
  background-color: transparent;
  border-radius: 4px;
  color: #000000;
  height: 24px;
  width: 24px;
}
.QyAwvbKssW .alMu_XgC8z .KjBq5KAfEX .juiQsOu8jX {
  margin-right: 24px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `J31AxeRQGR`,
	"color-row": `x1ADONo0L6`,
	"color-tile": `Yr7CdLY_B1`,
	"picker-component": `CUbqLuDTYG`,
	"picker-element": `XVT5ZaM29N`,
	"active": `HLQjdzJQG7`,
	"btn": `_QPctH5qP0`,
	"red-1": `PKrlhAeoZ7`,
	"red-2": `Q7_khx1zeZ`,
	"red-3": `ccAaR9tclE`,
	"red-4": `RswauI5XhD`,
	"red-5": `poVbWImNBp`,
	"red-6": `XeOizajuIi`,
	"orange-1": `OUyQZJ1YlH`,
	"orange-2": `ussZmt5FuA`,
	"orange-3": `z50XmiUntb`,
	"orange-4": `uYn7U1JRZp`,
	"orange-5": `DBcW0adQzX`,
	"orange-6": `V6Wgg6lKEp`,
	"green-1": `DsJ2nCt_iI`,
	"green-2": `KwQEw1EKQr`,
	"green-3": `c6pt_KFOzD`,
	"green-4": `ENkWT28QxW`,
	"green-5": `Gm6UgWc7mw`,
	"green-6": `kGNDCb65CK`,
	"blue-1": `SkQIlxqmCQ`,
	"blue-2": `igOjr2e8ss`,
	"blue-3": `z_VpsyhE0z`,
	"blue-4": `DXUWGrzIn8`,
	"blue-5": `fKXdDyPEG_`,
	"blue-6": `akhLJXWCN8`,
	"yellow-1": `KkWRzNNq9N`,
	"yellow-2": `QuETAfvsbs`,
	"yellow-3": `oBVWyDD99a`,
	"yellow-4": `OkJPOK2R4z`,
	"yellow-5": `Gmz_LmWqvO`,
	"yellow-6": `fBnPU3z3lQ`,
	"purple-1": `a7vPVtS1K0`,
	"purple-2": `i45IcBJrhw`,
	"purple-3": `NIDrFRJSRe`,
	"purple-4": `gIEISAGiUM`,
	"purple-5": `eWgf448ZVN`,
	"purple-6": `O2H2foTAVZ`,
	"black-1": `Ch4Q0Hk5wo`,
	"black-2": `Lhdu0M9fbY`,
	"black-3": `gUbAMwMEaJ`,
	"black-4": `VYyqi9NjDt`,
	"black-5": `g4qfE0fCGd`,
	"black-6": `FwWhWc002B`,
	"picker-theme": `XMVTtloyAv`,
	"arrow-regular": `xvz7k9lL5O`,
	"comments--root": `QyAwvbKssW`,
	"comments__header--ctn": `tILHymvLJN`,
	"comments__header--label": `v5BoAj8NcV`,
	"comments--ctn": `alMu_XgC8z`,
	"comment--root": `KjBq5KAfEX`,
	"comment--avatar": `e_zPfM1jBh`,
	"comment--reply-btn": `idr9BH3Uj2`,
	"comment__open-btn": `Ry2SOtq5vn`,
	"comment--secondary-action": `juiQsOu8jX`
};
export default ___CSS_LOADER_EXPORT___;
